import {LocaleEnum} from '@enums/locale';
import {faPenAlt} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useTranslation} from 'next-i18next';
import {useRouter} from 'next/router';
import Link from '@components/Common/Link';

interface IPageEditLinkProps {
  url: string;
}
const PageEditLink = ({url}: IPageEditLinkProps) => {
  const {t} = useTranslation('common');

  const gotoAdminPageEdit = () => {
    const adminFrontEndUrl = process.env.NEXT_PUBLIC_ADMIN_FRONTEND;
    window.open(`${adminFrontEndUrl}${url}`, '_blank');
  };
  return (
    <Link classNames="float-end" onClick={() => gotoAdminPageEdit()}>
      <FontAwesomeIcon icon={faPenAlt} />
      <span> {t<string>('edit_page')}</span>
    </Link>
  );
};

export default PageEditLink;
